import { Component } from './component';

export class SunkenPanel extends Component {
  public el: HTMLDivElement;

  constructor() {
    super();
    this.el = document.createElement('div');
    this.el.classList.add('sunken-panel');
  }
}
